/**
 * Live breakdown: pot = stake × memberCount; per-row computed payout.
 * stake mode = refund of entry fee (one participant's stake), fixed at `stake` each.
 * Percent rows apply to (pot − sum of all stake refunds). Currency rows stay fixed amounts.
 */
export function computePrizeBreakdown(stake, memberCount, slots) {
  const s = Number(stake) || 0;
  const n = Math.max(0, Number(memberCount) || 0);
  const pot = s * n;
  const sorted = [...(slots || [])].sort((a, b) => (Number(a.place) || 0) - (Number(b.place) || 0));

  let stakeRefundTotal = 0;
  for (const slot of sorted) {
    if (slot.mode === "stake") stakeRefundTotal += s;
  }

  const baseForPercent = Math.max(0, pot - stakeRefundTotal);

  const rows = sorted.map((slot) => {
    let computed = 0;
    if (slot.mode === "percent") {
      computed = baseForPercent * ((Number(slot.value) || 0) / 100);
    } else if (slot.mode === "currency") {
      computed = Number(slot.value) || 0;
    } else {
      computed = s;
    }
    return { ...slot, computed };
  });
  const allocated = rows.reduce((sum, r) => sum + r.computed, 0);
  return { pot, rows, allocated, remainder: pot - allocated };
}

export function normalizeSlotForApi(row) {
  const place = Math.max(1, Math.min(99, parseInt(String(row.place), 10) || 1));
  const mode = row.mode === "currency" || row.mode === "stake" ? row.mode : "percent";
  if (mode === "stake") {
    return { place, mode: "stake" };
  }
  const value = Number(row.value);
  return {
    place,
    mode,
    value: Number.isFinite(value) ? value : 0,
  };
}
